import { Component } from '@angular/core';
import { TeammateAvatarComponent } from './chats/teammates/teammate-avatar.component';
import { TEAMMATE_AVATAR_PRESETS } from './chats/teammates/teammate-avatar.config';

@Component({
  selector: 'squadbox-app-loading-screen',
  imports: [TeammateAvatarComponent],
  template: `
    <div
      class="fixed inset-0 z-51 flex items-center justify-center fade-in"
      [style.backgroundColor]="screenBackgroundColor"
    >
      <div class="h-40 w-40">
        <squadbox-teammate-avatar
          class="h-full w-full"
          [avatar]="avatarPreset"
          [looping]="true"
        />
      </div>
    </div>
  `,
})
export class AppLoadingScreenComponent {
  protected readonly avatarPreset = TEAMMATE_AVATAR_PRESETS.A;
  protected readonly screenBackgroundColor = `color-mix(in srgb, ${this.avatarPreset.baseColor} 16%, var(--color-shades-white) 84%)`;
}
